import React from 'react'
import { Link } from 'react-router-dom'

import { Helmet } from 'react-helmet'

import NavbarInteractive from '../components/navbar-interactive'
import ButtonOutline1 from '../components/button-outline1'
import Footer from '../components/footer'
import './x-input-documenten-en-fotos-twee-uit-duizenden.css'

const XINPUTDocumentenEnFotosTweeUitDuizenden = (props) => {
  return (
    <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container1">
      <Helmet>
        <title>Foto's Twee uit Duizenden</title>
        <meta name="description" content="Foto's uit de Tweede Wereldoorlog" />
        <meta property="og:title" content="Foto's Twee uit Duizenden" />
        <meta
          property="og:description"
          content="Foto's uit de Tweede Wereldoorlog"
        />
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-top">
        <NavbarInteractive rootClassName="navbar-interactiveroot-class-name16"></NavbarInteractive>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container2">
          <h1>Over mij</h1>
          <span>Schrijversacademie en daarna</span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container3">
        <h1 className="xinput-documenten-en-fotos-twee-uit-duizenden-text102">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text103">
            Foto&apos;s en documenten bij het boek
          </span>
          <br></br>
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text105">
            Als je niets bent
          </span>
          <br></br>
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text107 Schuingedrukt_tekst">
            De twee kanten van een oorlog
          </span>
          <br></br>
        </h1>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container4">
        <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text109 Schuingedrukt_tekst">
          alle foto&apos;s en documenten komen uit de privécollectie tenzij
          anders aangegeven
        </span>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container5">
        <img
          alt="image"
          src="/Albert Gerrits/0%20albert%20gerrits-400w.jpg"
          className="xinput-documenten-en-fotos-twee-uit-duizenden-gerrits"
        />
        <img
          alt="image"
          src="/Albert Woltjes/0%20albert%20woltjes-400w.jpg"
          className="xinput-documenten-en-fotos-twee-uit-duizenden-woltjes"
        />
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-oproep-tewerkstelling">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-oproep">
          <img
            alt="image"
            src="/Albert Gerrits/a1%20oproep%20arbeitseinsatz-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image10"
          />
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text110">
            <span>
              Bron: NIOD, Nederlands Instituut voor Oorlogs-, Holocaust- en
              Genocidestudies. Beeldnummer 107150.
            </span>
            <br></br>
          </span>
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst10">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text113">
            <span>
              Ab, geboren in 1921, dient zich op 17 mei 1943 aan te melden voor
              de Arbeitseinsatz. Zie bijgaande oproep.
            </span>
            <br></br>
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-diploma-vakbekwaamheid">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto10">
          <img
            alt="image"
            src="/Albert Gerrits/a2%20diploma%20kruideniersbedrijf-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-diploma"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst11">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text116">
            <span>
              Ab heeft de oproep voor de Arbeitseinsatz genegeerd en haalt tien
              dagen later zijn diploma Vakbekwaamheid Kruideniersbedrijf.
            </span>
            <span> </span>
            <br></br>
            <br></br>
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container10">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto11">
          <img
            alt="image"
            src="/Albert Gerrits/a3%20samen%20in%20oolde-2-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image11"
          />
          <img
            alt="image"
            src="/Albert Gerrits/a32%20luiken%20oolde-1000w.jpeg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image12"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst12">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text121">
            <span>
              Ab duikt onder bij een oom en tante in Oolde in de Achterhoek
              (1943). To komt op bezoek.
            </span>
            <br></br>
            <br></br>
            <span>
              Eronder de boerderij met nog steeds dezelfde luikjes in 2018.  
            </span>
            <br></br>
            <br></br>
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container11">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto12">
          <img
            alt="image"
            src="/Albert Gerrits/a4%20wachttoren%20amerfoort%20zwwit-1000w.jpeg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image13"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst13">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text128">
            <span>
              Ab wordt verraden en opgepakt en naar Kamp Amersfoort gebracht. Op
              de foto een wachttoren, nog steeds aanwezig bij het Nationaal
              Monument Kamp Amersfoort. 
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <br></br>
            <br></br>
            <span>
              Op oorlogsbronnen.nl kun je veel foto&apos;s vinden van Kamp
              Amersfoort in de Tweede Wereldoorlog. Zie
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <a
              href="https://www.oorlogsbronnen.nl/bronnen?term=kamp+amersfoort&amp;tab=foto&amp;page=1"
              target="_blank"
              rel="noreferrer noopener"
              className="xinput-documenten-en-fotos-twee-uit-duizenden-link"
            >
              https://www.oorlogsbronnen.nl/bronnen?term=kamp+amersfoort&amp;tab=foto&amp;page=1
            </a>
            <br></br>
            <span> </span>
            <br></br>
            <br></br>
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container12">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto13">
          <img
            alt="image"
            src="/Albert Gerrits/a5%20transportkaart%201%20en%202%20samen-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image14"
          />
          <img
            alt="image"
            src="/Albert Gerrits/a52%20transportlijst%20rheine%2018-04-44%20def-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image15"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst14">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text137">
            <span>
              Na zes weken Amersfoort wordt Ab met 498 anderen met de trein naar
              Rheine gebracht om op het vliegveld tewerkgesteld te worden.
              Eenmaal over de grens horen ze dat er geen plek is en worden ze
              naar concentratiekamp Buchenwald gebracht. Waarom op het eerste
              blad Buchenwald al vermeld stond?
            </span>
            <br></br>
            <span> </span>
            <br></br>
            <br></br>
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container13">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto14">
          <img
            alt="image"
            src="/Albert Gerrits/a6%20buchenwald%20poort-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image16"
          />
          <img
            alt="image"
            src="/Albert Gerrits/a62%20jedem%20das%20seine1-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image17"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst15">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text143">
            <span>
              Op 19 april 1944 komen ze aan in concentratiekamp Buchenwald bij
              Weimar met de tekst in de poort: Jedem das Seine (Ieder het
              zijne).
            </span>
            <span> </span>
            <br></br>
            <br></br>
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container14">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto15">
          <img
            alt="image"
            src="/Albert Gerrits/a7%20bw%20kaart%201-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image18"
          />
          <img
            alt="image"
            src="/Albert Gerrits/a72%20bw%20kaart%202-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image19"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst16">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text148">
            <span>
              In concentratiekamp Buchenwald moet hij zijn spullen afgeven, die
              op verschillende kaarten geregistreerd worden.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <br></br>
            <br></br>
            <span>
              Daaronder zijn gevangenenregistratie met foto. Hoe het
              registratieproces eraan toeging, lees je in mijn boek.
            </span>
            <br></br>
            <br></br>
            <span>
              Later is in het rood toegevoegd dat de kleding door de vijand
              vernietigd is. Buchenwald is op 24 augustus 1944 door de
              Amerikanen gebombardeerd.
            </span>
            <br></br>
            <span> </span>
            <br></br>
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container15">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto16">
          <img
            alt="image"
            src="/Albert Gerrits/a8%20kommando%20zimmerei-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image20"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst17">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text159">
            <span>
              Als Ab weg wilde bij een arbeidscommando, ging hij stiekem bij een
              ander commando staan. Dat hij nooit betrapt is mag een wonder
              heten. Hier zie je dat hij niet is komen opdagen voor de
              timmerwerk-zaamheden bij de Deutsche Ausrüstungswerke (nicht
              weiter angetreten staat dwars achter zijn naam).
            </span>
            <br></br>
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container16">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto17">
          <img
            alt="image"
            src="/Albert Gerrits/a9%20brief%20ab4%20voorkant%20juni%2044-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image21"
          />
          <img
            alt="image"
            src="/Albert Gerrits/a92%20brief%20ab4%20juni%2044-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image22"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst18">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text162">
            <span>
              Een van de bewaard gebleven brieven die Ab naar huis geschreven
              heeft. De streep erdoorheen geeft aan dat deze gecensureerd is.
            </span>
            <br></br>
            <br></br>
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container17">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto18">
          <img
            alt="image"
            src="/Albert Gerrits/b1%20pa%20in%20buchenwald%20hek%20klein-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image23"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst19">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text166">
            <span>
              Op zijn tachtigste is hij terug in Buchenwald en heeft hij zijn
              herinneringen met mij gedeeld.  Hier staat hij voor de ingang van
              het voormalige kamp.
            </span>
            <br></br>
            <br></br>
            <br></br>
            <span> </span>
            <br></br>
            <br></br>
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-banner">
        <Link
          to="/roman"
          className="xinput-documenten-en-fotos-twee-uit-duizenden-navlink"
        >
          <ButtonOutline1
            text="Naar de roman"
            button1="Over de roman"
            rootClassName="button-outline1root-class-name7"
            buttonOutlineId="Button outline"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-component2"
          ></ButtonOutline1>
        </Link>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-eerste-foto-woltjes">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto19">
          <img
            alt="image"
            src="/Albert Woltjes/a1%20hj-pas-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image24"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst20">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text174">
            Albert Woltjes wordt lid van de Hitler-Jugend. Dit is zijn
            Mitglieds-Ausweis.
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container18">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto20">
          <img
            alt="image"
            src="/Albert Woltjes/a2%20bakkerij-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image25"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst21">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text175">
            De woning waar Albert opgroeide met onderin de winkel en rechts de
            bakkerij. 
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container19">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto21">
          <img
            alt="image"
            src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image26"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst22">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text176">
            De propagandamachine werkte goed. Hier zie je de voorkant en een van
            de binnenpagina&apos;s van het door Albert fel begeerde plakboek.
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container20">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto22">
          <img
            alt="image"
            src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image27"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst23">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text177">
            Op de eerste foto het handboek voor het Jungvolk: &quot;Pimpf im
            Dienst&quot;. Verder drie tijdschriften van &quot;Der Pimpf&quot;.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container21">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto23">
          <img
            alt="image"
            src="/Albert Woltjes/a5%20leistungsbuch%20hj-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image28"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst24">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text178">
            Twee pagina&apos;s uit het Leistungsbuch. Een boekje met uitleg waar
            je aan moet voldoen om van het Jungvolk (10 tot 14 jaar) naar de
            Hitlerjugend (14 - 18 jaar) over te mogen gaan. De prestaties werden
            hierin nauwkeurig bijgehouden.
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container22">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto24">
          <img
            alt="image"
            src="/Albert Woltjes/a6%20bakkersdiploma-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image29"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst25">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text179">
            Na drie jaar in de leer te zijn geweest bij bakker Borchelt ontvangt
            Albert in maart 1942 zijn bakkersdiploma.  
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container23">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto25">
          <img
            alt="image"
            src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image30"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst26">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text180">
            In je 18e levensjaar werd je opgeroepen voor de Reichsarbeitsdienst
            (RAD). Albert is de tweede van links op de achterste rij. De eerste
            maanden was hij in Assel bij Stade. 
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container24">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto26">
          <img
            alt="image"
            src="/Albert Woltjes/a8%20rad%20lille-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image31"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst27">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text181">
            Na twee maanden opleiding gingen ze naar Frankrijk, waar ze ingezet
            werden voor allerlei hand- en spandiensten, zoals het voorbereiden
            van een terrein voor de installatie van de V1.
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container25">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto27">
          <img
            alt="image"
            src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image32"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst28">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text182">
            <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text183">
              Als rekruut in Denemarken. Infanterie-opleiding. Op de bovenste
              foto staat Albert rechts vooraan en op de onderste foto links.
            </span>
            <br></br>
            <br></br>
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container26">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto28">
          <img
            alt="image"
            src="/Albert Woltjes/b1%20huis%20in%20puin-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image33"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst29">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text186">
            <span>
              Het huis en de aanpalende bakkerij op de Hastedter Heerstrasse in
              Bremen zijn verschillende keren beschadigd door bombardementen. De
              ergste keer was op 20 december 1943.
            </span>
            <br></br>
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container27">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto29">
          <img
            alt="image"
            src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image34"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst30">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text189">
            <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text190">
              In dienst bij de Wehrmacht in Mimizan en omgeving. Hij woonde
              enige tijd in een treinwagon en zorgde voor de voedselvoorziening
              voor de soldaten. Albert zit rechts achter de ezel.
            </span>
            <br></br>
            <br></br>
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container28">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto30">
          <img
            alt="image"
            src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image35"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst31">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text193">
            <span>Zijn soldatenboek, tevens identiteitsbewijs.</span>
            <br></br>
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container29">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto31">
          <img
            alt="image"
            src="/Albert Woltjes/b4%20bericht%20krijgsgevangenschap1-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image36"
          />
          <img
            alt="image"
            src="/Albert Woltjes/b42%20bericht%20krijgsgevangenschap2-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image37"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst32">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text196">
            <span>
              Via deze kaart werden Alberts ouders bericht over zijn
              krijgsgevangenschap.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <br></br>
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container30">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto32">
          <img
            alt="image"
            src="/Albert Woltjes/b5%20doggy%20tag-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image38"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst33">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text199">
            <span>
              Doggy tag en registratie van de &quot;cage&quot; waar Albert in
              Amerikaanse gevangenschap in Cherbourg geplaatst werd. 
            </span>
            <br></br>
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container31">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto33">
          <img
            alt="image"
            src="/Albert Woltjes/b6%20frans%20gevangenenummer-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image39"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst34">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text202">
            <span>
              In augustus 1945 werd hij overgedragen aan de Fransen. Hij kreeg
              een PG-nummer (prisonnier de guerre) en werd naar diverse
              commando&apos;s gestuurd.  
            </span>
            <br></br>
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container32">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto34">
          <img
            alt="image"
            src="/Albert Woltjes/b7%20vermissing%20gerhard%20-%20kl-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image40"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst35">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text205">
            <span>
              Ouders krijgen bericht over de vermissing van hun zoon en Alberts
              broer Gerhard. Albert zit dan in Frankrijk.
            </span>
            <span>
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <br></br>
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container33">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto35">
          <img
            alt="image"
            src="/Albert Woltjes/b8%20steenfabriek-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image41"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst36">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text209">
            <span>
              Drie foto&apos;s van de steenfabriek waar Albert lange tijd als
              krijgsgevangene tewerkgesteld was, de Tuilerie
              Saint-Parres-les-Vaudes. Albert staat op de middelste foto, tweede
              van rechts. 
            </span>
            <br></br>
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container34">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto36">
          <img
            alt="image"
            src="/Albert Woltjes/b9%20brief%20samen-1000w.jpeg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image42"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst37">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text212">
            <span>
              Voor- en achterkant van een van de vele brieven die Albert (in het
              Sütterlin) naar huis geschreven heeft. 
            </span>
            <br></br>
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container35">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto37">
          <img
            alt="image"
            src="/Albert Woltjes/c1%20entlassungsschein-1-1000w.jpeg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image43"
          />
        </div>
        <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text215">
          <span>Ontslagen uit krijgsgevangenschap</span>
          <br></br>
        </span>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst38"></div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container36">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto38">
          <img
            alt="image"
            src="/Albert Woltjes/c2%20herbouw%20huis-1000w.jpg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image44"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst39">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text218">
            <span>
              Het door bombardement verwoeste en geïmproviseerde huis wordt
              eindelijk herbouwd.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <br></br>
          </span>
        </div>
      </div>
      <div className="xinput-documenten-en-fotos-twee-uit-duizenden-buitenste-container37">
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-foto39">
          <img
            alt="image"
            src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
            className="xinput-documenten-en-fotos-twee-uit-duizenden-image45"
          />
        </div>
        <div className="xinput-documenten-en-fotos-twee-uit-duizenden-container-tekst40">
          <span className="xinput-documenten-en-fotos-twee-uit-duizenden-text221">
            <span>
              Albert voor de ovens in de bakkerij.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <br></br>
          </span>
        </div>
      </div>
      <Footer rootClassName="footerroot-class-name17"></Footer>
    </div>
  )
}

export default XINPUTDocumentenEnFotosTweeUitDuizenden
